module.exports = __webpack_public_path__ + "poland.svg?6e10627c38977fc1e5f52aef932a6f5a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/poland.svg
// module id = 268
// module chunks = 10